import { motion } from "framer-motion";
import { Building2, TrendingUp, ArrowRightLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const pillars = [{
  icon: Building2,
  title: "Construir",
  description: "Cuando existe valor empresarial, pero todavía no fue convertido en una posición clara, diferenciada y reconocible."
}, {
  icon: TrendingUp,
  title: "Elevar",
  description: "Cuando la empresa evolucionó, pero la percepción que construye quedó por debajo de su verdadero nivel."
}, {
  icon: ArrowRightLeft,
  title: "Transferir",
  description: "Extender Capital de Marca hacia una empresa, nueva generación, unidad, franquicia, producto u otro activo."
}];

const Solution = () => {
  const scrollToCalendly = () => {
    const calendlySection = document.getElementById("calendly");
    if (calendlySection) {
      calendlySection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return <section className="py-24 md:py-32 relative overflow-hidden bg-foreground text-background" id="solucion">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-neutral-900 to-black" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 rounded-full blur-3xl" />
      
      <div className="container px-4 relative z-10">
        {/* Section header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-4xl mx-auto mb-20">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight">
            CONSTRUIR. ELEVAR. TRANSFERIR.
          </h2>
          <p className="text-lg text-neutral-400 max-w-3xl mx-auto">
            Tres movimientos. Una misma dirección: hacer que el valor se convierta en Capital de Marca.
          </p>
        </motion.div>

        {/* Pillars grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-16">
          {pillars.map((pillar, index) => <motion.div key={pillar.title} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="group">
              <div className="bg-gradient-to-b from-[#0a1628] to-[#0d1e36] backdrop-blur-sm rounded-2xl p-8 h-full border border-blue-900/40 hover:border-blue-500/50 transition-all duration-500 hover:shadow-lg hover:shadow-blue-500/20">
                {/* Icon */}
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-blue-500/30">
                  <pillar.icon className="w-8 h-8 text-white" />
                </div>

                {/* Title */}
                <h3 className="font-display text-2xl font-bold text-white mb-4">
                  {pillar.title}
                </h3>

                {/* Description */}
                <p className="text-blue-100/70 leading-relaxed">
                  {pillar.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-center"
        >
          <Button variant="gold" size="xl" onClick={scrollToCalendly} className="tracking-wider font-semibold rounded-full">
            DESCUBRIRLO CON CORESSEN
          </Button>
        </motion.div>
      </div>
    </section>;
};
export default Solution;
